export enum EscriptTriageReasons {
  patientMatch = 'patientMatch',
  customerUnknown = 'customerUnknown',
  missingDaysSupply = 'missingDaysSupply',
  other = 'other',
}
